const StatusList = [
    "active",
    "deactivate",
    'require_payment'
];
export default StatusList;
